var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { parseError } from "@ane/core/lib/utils/ErrorUtils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const apiVersion = "2021-06-09";
let apiVersionForProfilingList = "2021-06-09";
if (EnvironmentService.releaseDSMSdataprofiling()) {
  apiVersionForProfilingList = "2021-11-11";
}
let DataSourceListResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.dsms, "", parseError);
  }
  getDataSourceList(workspaceId, search, dataSourceType) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/DataSources/paging?apiVersion=${apiVersionForProfilingList}`;
      if (!!search) {
        address = `/workspaces/${workspaceId}/DataSources/search?apiVersion=${apiVersionForProfilingList}&query=${search}`;
      }
      if (!!dataSourceType) {
        address = `/workspaces/${workspaceId}/DataSources/search?apiVersion=${apiVersionForProfilingList}&query=${search}&dataSourceType=${dataSourceType}`;
      }
      const result = yield this._get(address);
      return result;
    });
  }
  triggerValidate(workspaceId, dataSourceName) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/DataSources/${dataSourceName}/validate?apiVersion=${apiVersion}`;
      const result = yield this._post({}, address);
      return result;
    });
  }
  postDataSource(postParams) {
    return __async(this, null, function* () {
      const address = `/workspaces/${postParams.WorkspaceId}/DataSources?apiVersion=${apiVersion}`;
      const result = yield this._post(postParams, address);
      return result;
    });
  }
  postDuplicateDataSource(postParams) {
    return __async(this, null, function* () {
      const address = `/workspaces/${postParams.WorkspaceId}/DataSources/Duplicates?apiVersion=${apiVersion}`;
      const result = yield this._post(postParams, address);
      return result;
    });
  }
  putDataSource(postParams, baseOnVersion) {
    return __async(this, null, function* () {
      const address = void 0 === baseOnVersion ? `/workspaces/${postParams.WorkspaceId}/DataSources?apiVersion=${apiVersion}` : `/workspaces/${postParams.WorkspaceId}/DataSources?apiVersion=${apiVersion}&baseOnVersion=${baseOnVersion}`;
      const result = yield this._put(postParams, address);
      return result;
    });
  }
  cloneDataSource(dataSourceClonePost) {
    return __async(this, null, function* () {
      const address = `/workspaces/${dataSourceClonePost.workspaceId}/DataSources/${dataSourceClonePost.name}/CloneFrom/${dataSourceClonePost.source}?apiVersion=${apiVersion}`;
      const result = yield this._post(dataSourceClonePost, address);
      return result;
    });
  }
  deleteDataSource(workspaceId, name) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/DataSources/${name}?apiVersion=${apiVersion}`;
      const result = yield this._delete(address);
      return result;
    });
  }
  getDataSource(workspaceId, name) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/DataSources/${name}?apiVersion=${apiVersion}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getDataSourceSchema(workspaceId, name) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/DataSources/${name}/schema?apiVersion=${apiVersion}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getDataSourceHistory(workspaceId, name) {
    return __async(this, null, function* () {
      let apiVersionForHistory = "2021-11-11";
      const address = `/workspaces/${workspaceId}/DataSources/${name}/history?apiVersion=${apiVersionForHistory}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getDataSourceStatus(workspaceId, name) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/DataSources/${name}/status-all?apiVersion=${apiVersion}&withDebugInfo=true`;
      const result = yield this._get(address);
      return result;
    });
  }
  getDataSourceAccess(workspaceId, name) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/DataSources/${name}/Access?apiVersion=${apiVersion}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getDataSourceOverrideList(workspaceId, name) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/DataSources/${name}/override?apiVersion=${apiVersion}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getSupportedFlightFormats(workspaceId, dataSourceType) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/supportedFlightFormats?apiVersion=${apiVersion}&dataSourceType=${dataSourceType}`;
      const result = yield this._get(address);
      return result;
    });
  }
  triggerDataProfiling(workspaceId, dataSourceProfiling) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/dataProfile/postJobSubmitRequest?apiVersion=${apiVersion}`;
      const result = yield this._post(dataSourceProfiling, address);
      return result;
    });
  }
};
DataSourceListResource = __decorateClass([
  WPSProxyConverter()
], DataSourceListResource);
const DataSourceResource = new DataSourceListResource();
export {
  DataSourceResource as default
};
//# sourceMappingURL=DataSource.resource.js.map
